import { getPayInfo, setPayInfo, getAddressId, setAddressId } from '@/utils/Address.js'

const state = {
  addressId: '', // 支付地址
  payTpye: '', // 支付方式
  payInfo: [],
  paymentType: {
    cart: 2,
    buyNow: 1
  }
}

const mutations = {
  SET_ADDRESSID: (state, addressId) => {
    if (addressId) {
      setAddressId(addressId)
      state.addressId = addressId
    }
  },
  GET_ADDRESSID: (state) => {
    if (state.addressId) {
      return state.addressId
    }
  },
  SET_PAYINFO: (state, info) => {
    const payment = getPayInfo()
    const { payInfo, payType } = info

    if (payInfo && payType) {
      state.payInfo = payInfo
      state.payTpye = payType
      const data ={
        payInfo: state.payInfo,
        payType: state.payTpye
      }
      if (payment) {
        setPayInfo(data)
      } else {
        setPayInfo({
          ...payment,
          ...data
        })
      }
    }
  }
}

const actions = {

}

const getters = {
  getAdddreId: state => {
    if (state.addressId) {
      return state.addressId
    } else {
      return getAddressId()
    }
  },
  getPayInfo: state => {
    if (state.payInfo && state.payTpye) {
      return {
        payInfo: state.payInfo,
        payType: state.payTpye
      }
    } else {
      return getPayInfo()
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
